import type { DesktopFeatures } from '.';

export const desktopFeatureLabels: { [K in keyof DesktopFeatures]: string } = {
  duration: "Advertise your business until it's sold.",
  boostedAds: 'Maximise your exposure whilst your ad is live on site.',
  price: 'Pay a fixed price and no commissions.',
  refresh: 'Unlimited ad editing and automated monthly ad refresh.',
  tools:
    'Price guide calculator, business sale checklist, buyer screening guide.',
};

export const desktopRenderOrder: Array<keyof DesktopFeatures> = [
  'price',
  'refresh',
  'tools',
  'duration',
  'boostedAds',
];

const desktopFeatureSortCompare = (a: string, b: string): number => {
  // "desktopRenderOrder as string[]" is safe as "indexOf" will return -1
  const indexOfA = (desktopRenderOrder as string[]).indexOf(a);
  const indexOfB = (desktopRenderOrder as string[]).indexOf(b);

  if (indexOfA < indexOfB) {
    return -1;
  } else if (indexOfA > indexOfB) {
    return 1;
  }
  return 0;
};

export const sortDesktopFeatures = <T>(features: {
  [K in keyof DesktopFeatures]: T;
}) =>
  Object.entries(features).sort((a, b) =>
    desktopFeatureSortCompare(a[0], b[0]),
  );
